import {Tooltip} from "@mui/material"
import {DATE_FORMAT_SHOW} from "../../../../../utils/constants"
import dayjs from "dayjs"
import {formatValue, renderCellWithTooltip} from "../../Utils/precos-pu-tir-constants"
import React from "react"
import ButtonWithIcon from "../../../../components/Button/Button"
import { ReactComponent as CharIcon } from "src/v2/assets/icons/chart-icon.svg"

export const columnsPriceTable = (date, handleOpenChart) => [
    {
        field: 'Gráfico',
        width: 60,
        minWidth: 80,
        renderCell: (params) => (
            <ButtonWithIcon
                size={"sm"}
                icon={<CharIcon />}
                onClick={() => handleOpenChart(params.row)}
            >
            </ButtonWithIcon>
        )
    },
    {
        field: 'DataReferencia',
        headerName: 'Data Referência',
        width: 115,
        type: 'date',
        valueGetter: () => date && dayjs(date).toDate(),
        valueFormatter: () => dayjs(date).format(DATE_FORMAT_SHOW),
    },
    {
        field: 'CETIP',
        headerName: 'CETIP',
        flex: true,
        maxWidth: 120,
        minWidth: 95,
        renderCell: renderCellWithTooltip,
    },
    {
        field: 'tipo_ativo',
        headerName: 'Tipo',
        width: 30,
    },
    {
        field: 'DataVencimento',
        headerName: 'Vencimento',
        width: 115,
        type: 'date',
        valueGetter: (params) => {
            if (!params.value) return null
            return dayjs(params.value).toDate()
        },
        valueFormatter: (params) => {
            if (params.value === "" || params.value == null) {
                return ""
            }
            const dataDayjs = dayjs(params.value)
            if (!dataDayjs.isValid()) {
                return ""
            }
            return dataDayjs.format(DATE_FORMAT_SHOW)
        },
    },
    {
        field: 'devedor',
        headerName: 'Devedor',
        minWidth: 140,
        renderCell: renderCellWithTooltip,
    },
    {
        field: 'indicador',
        headerName: 'Indicador',
        minWidth: 40,
    },
    {
        field: 'taxa_accrual',
        headerName: 'Taxa ACCRUAL',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                    <span>{valueFormated}</span>
                </Tooltip>
            )
        },
    },
    {
        field: 'TaxaMTM',
        headerName: 'Taxa MTM',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                    <span>{valueFormated}</span>
                </Tooltip>
            )
        },
    },
    {
        field: 'SpreadCredito',
        headerName: 'Spread Crédito',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    {
        field: 'PU_Inf',
        headerName: 'PU MIN',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    {
        field: 'PU_MTM',
        headerName: 'PU MTM',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    {
        field: 'PU_Sup',
        headerName: 'PU MAX',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    {
        field: 'PUPAR',
        headerName: 'PUPAR',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    {
        field: 'PercentualPUPAR',
        headerName: '%PUPAR',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    {
        field: 'DurationMTM',
        headerName: 'Duration DU',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    {
        field: 'DurationAno',
        headerName: 'Duration Ano',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    // {
    //     field: 'IndiceLiquidez',
    //     headerName: 'Índice Liquidez',
    //     flex: 1,
    //     minWidth: 100,
    //     type: 'number',
    //     valueFormatter: (params) => {
    //         if (params.value === "" || params.value == null || isNaN(Number(params.value))) {
    //             return ""
    //         }
    //         return params.value
    //     }
    // },
    {
        field: 'DataEventoProximo',
        headerName: 'Data Evento Proximo',
        minWidth: 130,
        type: 'date',
        valueGetter: (params) => {
            if (!params.value) return null
            return dayjs(params.value).toDate()
        },
        valueFormatter: (params) => {
            if (params.value === "" || params.value == null) {
                return ""
            }
            const dataDayjs = dayjs(params.value)
            if (!dataDayjs.isValid()) {
                return ""
            }
            return dataDayjs.format(DATE_FORMAT_SHOW)
        },
    },
    {
        field: 'ValorProximoEvento',
        headerName: 'Valor Proximo Evento',
        flex: 1,
        minWidth: 180,
        renderCell: (params) => {
            if (params.value === "" || params.value == null || isNaN(Number(params.value))) {
                return ""
            }
            const valueFormated = formatValue(params)
            return (
                <Tooltip title={valueFormated} placement="bottom-start">
                        <span>
                            {valueFormated}
                        </span>
                </Tooltip>
            )
        },
    },
    // {
    //     field: 'PremioRecompra',
    //     headerName: 'Premio Recompra',
    //     flex: 1,
    //     minWidth: 120,
    //     renderCell: (params) => {
    //         if (params.value === "" || params.value == null || isNaN(Number(params.value))) {
    //             return ""
    //         }
    //         const valueFormated = formatValue(params)
    //         return (
    //             <Tooltip title={valueFormated} placement="bottom-start">
    //                     <span>
    //                         {valueFormated}
    //                     </span>
    //             </Tooltip>
    //         )
    //     },
    // },
    // {
    //     field: 'SpreadRecompra',
    //     headerName: 'Spread Recompra',
    //     flex: 1,
    //     minWidth: 120,
    //     renderCell: (params) => {
    //         if (params.value === "" || params.value == null || isNaN(Number(params.value))) {
    //             return ""
    //         }
    //         const valueFormated = formatValue(params)
    //         return (
    //             <Tooltip title={valueFormated} placement="bottom-start">
    //                     <span>
    //                         {valueFormated}
    //                     </span>
    //             </Tooltip>
    //         )
    //     },
    // },
    // {
    //     field: 'PremioaPagar',
    //     headerName: 'Prêmio a Pagar',
    //     flex: 1,
    //     minWidth: 120,
    //     renderCell: (params) => {
    //         if (params.value === "" || params.value == null || isNaN(Number(params.value))) {
    //             return ""
    //         }
    //         const valueFormated = formatValue(params)
    //         return (
    //             <Tooltip title={valueFormated} placement="bottom-start">
    //                     <span>
    //                         {valueFormated}
    //                     </span>
    //             </Tooltip>
    //         )
    //     },
    // },

]